"use client";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export type PendingDesignAction = "tryOn" | "quote";

export default function PendingDesignActionDialog({
  action,
  open,
  onRestoreFocus,
  onOpenChange,
  onUseGenerated,
  onApplyFirst,
  creditCost,
  applyDisabled,
  applyReason,
  generatedUnavailable,
}: {
  action: PendingDesignAction;
  open: boolean;
  onRestoreFocus: () => void;
  onOpenChange: (open: boolean) => void;
  onUseGenerated: () => void;
  onApplyFirst: () => void;
  creditCost: number;
  applyDisabled: boolean;
  applyReason?: string | null;
  generatedUnavailable?: boolean;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        title={null}
        className="designer-pending-dialog rounded-2xl sm:max-w-md"
        onCloseAutoFocus={event => {
          event.preventDefault();
          onRestoreFocus();
        }}
      >
        <DialogHeader>
          <DialogTitle className="pr-8">Use your current preview?</DialogTitle>
          <DialogDescription>
            You have pending changes.{" "}
            {action === "tryOn" ? "Your try-on" : "Your quote"} will use the
            dress in your current preview unless you apply them first.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-2">
          <Button
            className="designer-primary h-12 w-full"
            onClick={onUseGenerated}
            disabled={generatedUnavailable}
          >
            {action === "tryOn"
              ? "Try on current dress"
              : "Get quote for current dress"}
          </Button>
          <Button
            variant="outline"
            className="designer-control h-12 w-full"
            onClick={onApplyFirst}
            disabled={applyDisabled}
          >
            Apply changes first · {creditCost}{" "}
            {creditCost === 1 ? "credit" : "credits"}
          </Button>
          {generatedUnavailable ? (
            <p className="text-xs text-muted-foreground">
              This preview has no saved details. Apply your changes before
              getting a quote.
            </p>
          ) : null}
          {applyDisabled && applyReason ? (
            <p className="text-xs text-muted-foreground">{applyReason}</p>
          ) : null}
          <Button
            variant="ghost"
            className="designer-control h-11"
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
